module.exports = __webpack_public_path__ + "static/img/screenshot.983013d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshot.png
// module id = g7zM
// module chunks = 1